import { BUSINESS_UNITS } from '@common/constants/BusinessUnits';
import { SERVICES } from '@common/constants/Services';
import { IBusinessUnitModel } from '@common/models/Businesses/BusinessUnit';

import { ChatConfig, getConfigValue } from '..';

export enum WorkingHours {
	TWENTY_FOUR = 24,
	FORTY_EIGHT = 48,
	NONE = 0,
}

export const WorkingHoursConstants: ChatConfig<WorkingHours> = {
	DEFAULT: WorkingHours.TWENTY_FOUR,
	CONFIG: {
		[`${SERVICES.ACADEMY}-${BUSINESS_UNITS.STUDY_ACADEMY}`]: WorkingHours.FORTY_EIGHT,
		[`${SERVICES.ACADEMY}-${BUSINESS_UNITS.IT_ACADEMY}`]: WorkingHours.FORTY_EIGHT,
		[`${SERVICES.TRAINING_CENTER}-${BUSINESS_UNITS.TRAINING_CENTER}`]: WorkingHours.NONE,
	},
};

/**
 * Function to get working hours of a mentor/teacher based on serviceId and business unit.
 *
 * @param {number} serviceId - The ID representing the selected service.
 * @param {IBusinessUnitModel[]} businessUnits - List of business units.
 * @returns {string} - Returns the string that displays this work hours.
 */
export function getWorkingHoursString(
	serviceId: number,
	businessUnits: IBusinessUnitModel[],
): string {
	const workingHours = getConfigValue(WorkingHoursConstants, serviceId, businessUnits);

	switch (workingHours) {
		case WorkingHours.TWENTY_FOUR:
			return `within ${WorkingHours.TWENTY_FOUR} hours`;
		case WorkingHours.FORTY_EIGHT:
			return `within ${WorkingHours.FORTY_EIGHT} hours`;
		case WorkingHours.NONE:
			return 'None';

		default:
			return null;
	}
}

/**
 * Function to get working hours of a mentor/teacher based on serviceId and business unit.
 *
 * @param {number} serviceId - The ID representing the selected service.
 * @param {IBusinessUnitModel[]} businessUnits - List of business units.
 * @returns {number} - Returns the corresponding working hours as a number.
 */
export function getWorkingHoursValue(
	serviceId: number,
	businessUnits: IBusinessUnitModel[],
): number {
	return getConfigValue(WorkingHoursConstants, serviceId, businessUnits);
}
